
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7hDnX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $62ae80b0ab2ec39c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $62ae80b0ab2ec39c$export$2e2bcd8739ae039 = {
    'fabric.reactions.add': "\u65B0\u589E\u53CD\u61C9",
    'fabric.reactions.error.unexpected': "\u66AB\u6642\u7121\u6CD5\u4F7F\u7528\u56DE\u8986\u529F\u80FD",
    'fabric.reactions.loading': "\u6B63\u5728\u8F09\u5165...",
    'fabric.reactions.more.emojis': "\u66F4\u591A\u8868\u60C5\u7B26\u865F",
    'fabric.reactions.other.reacted.users': "{count, plural, other {\u9084\u6709\u5176\u4ED6 {count} \u500B}}",
    'fabric.reactions.reactwithemoji': "\u4F7F\u7528 {emoji} \u8868\u60C5\u7B26\u865F\u56DE\u61C9",
    'fabric.reactions.summary': "\u6AA2\u8996\u6240\u6709\u4F7F\u7528\u8005\u7684\u56DE\u61C9",
    'reaction-picker-trigger.add.reaction.message': "\u65B0\u589E\u56DE\u61C9",
    'reactions.dialog.close': "\u95DC\u9589",
    'reactions.dialog.left.navigate': "\u5DE6\u5074\u5C0E\u89BD",
    'reactions.dialog.reactions.count': "{count, plural, other {{count,number} \u500B\u56DE\u61C9\u7E3D\u8A08}}",
    'reactions.dialog.right.navigate': "\u53F3\u5074\u5C0E\u89BD",
    'reactions.dialog.viewall': "\u67E5\u770B\u5168\u90E8",
    'reactions.dialog.viewall.tooltip': "\u6AA2\u8996\u6240\u6709\u4F7F\u7528\u8005\u7684\u56DE\u61C9"
};

});


//# sourceMappingURL=zh_TW.d732e8de.js.map
